import type { ComponentType } from 'react'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded'
import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
import { MobileTabRow, type MobileTabItem } from '../Common/MobileTabs'
import { useNls } from '../../nls/nlsProvider'
import { getHelperFieldSubtabLabel, type HelperFieldSubtab } from './helperFieldModel'

export type HelperFieldSubtabStripProps = {
  subtabs: HelperFieldSubtab[]
  active: HelperFieldSubtab
  onChange: (next: HelperFieldSubtab) => void
  t: ReturnType<typeof useNls>['t']
  className?: string
  counts?: Partial<Record<HelperFieldSubtab, number>>
  placement?: 'top' | 'bottom'
}

const FIELD_SUBTAB_ICONS: Record<HelperFieldSubtab, ComponentType<{ fontSize?: 'inherit' | 'small' | 'large' | 'medium'; style?: React.CSSProperties }>> = {
  TODAY: ScheduleRoundedIcon,
  SCAN: QrCodeScannerRoundedIcon,
  COUNT: PlaylistAddCheckRoundedIcon,
  ME: PersonRoundedIcon,
}

export const HelperFieldSubtabStrip = ({
  subtabs,
  active,
  onChange,
  t,
  className,
  counts,
  placement = 'bottom',
}: HelperFieldSubtabStripProps) => {
  if (subtabs.length === 0) return null

  const items: Array<MobileTabItem<HelperFieldSubtab>> = subtabs.map((key) => {
    const Icon = FIELD_SUBTAB_ICONS[key]
    return {
      key,
      label: getHelperFieldSubtabLabel(key, t),
      icon: Icon ? <Icon fontSize="small" style={{ fontSize: 16 }} /> : undefined,
      count: counts?.[key],
      testId: `helper-field-subtab-${key.toLowerCase()}`,
    }
  })

  return (
    <div className={className} data-testid="helper-field-subtab-strip">
      <MobileTabRow
        items={items}
        activeKey={active}
        onChange={onChange}
        ariaLabel={t('NLSHelperFieldSubtabsAria')}
        variant="underline"
        testId="helper-field-subtab-row"
        placement={placement}
        overflowStrategy="scroll"
      />
    </div>
  )
}
